module.exports = __webpack_public_path__ + "img/b76b6bd.png";